export default {
  IMG_EXTENSIONS: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
  ALL_EXTENSIONS_STRING: '.png,.jpg,.mp4,.mov,.obj,.pdf,.ma,.mb,.zip,' +
    '.rar,.jpeg,.svg,.blend,.wmv,.m4v,.ai,.comp,.exr,.psd,.hip,.gif,.ae,' +
    '.fla,.flv,.swf,.sbbkp',
  ALL_EXTENSIONS: [
    'png', 'jpg', 'mp4', 'mov', 'obj', 'pdf', 'ma', 'mb', 'zip', 'rar',
    'jpeg', 'svg', 'blend', 'wmv', 'm4v', 'ai', 'comp', 'exr', 'psd', 'hip',
    'gif', 'ae', 'fla', 'flv', 'swf', 'sbbkp'
  ]
}
